var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M26,12.3h3.7v-0.9c0-0.7-0.3-1.3-0.9-1.6c-0.6-0.3-1.3-0.3-1.9,0c-0.5,0.4-0.9,1-0.9,1.6L26,12.3z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M5.6,30.2c-0.1,0.2-0.1,0.4,0,0.6c0.2,0.1,0.4,0.1,0.6,0l2.9-3l6,5.9l-3,3c-0.1,0.2-0.1,0.4,0,0.6 c0.2,0.1,0.4,0.1,0.6,0l2.9-3l0.6,0.5c0,0.1,0.1,0.1,0.3,0.1c0.2,0,0.2,0,0.2-0.1l2.5-2.4c0.1-0.2,0.1-0.4,0-0.6l-1-0.9l1.3-1.2h9.4 c1,0,1.9-0.4,2.6-1.1L39,21c0.7-0.6,0.8-1.7,0.2-2.4c-0.1-0.1-0.1-0.1-0.2-0.2c-0.7-0.7-1.9-0.7-2.6,0l-5.5,5.5 c-0.3-0.7-1-1.1-1.7-1.1h-6.1l-0.7-0.5c-2.6-1.8-6.2-1.5-8.5,0.7L12,24.6l-0.9-0.9h-0.6L8,26.1c0,0.1-0.1,0.2-0.1,0.3S8,26.6,8,26.7 l0.6,0.5L5.6,30.2z M14.5,23.6c2-1.9,5.1-2.2,7.4-0.6l0.8,0.5h6.5c0.6,0,1,0.4,1,1s-0.4,1-1,1h-6.7c-0.2,0-0.4,0.2-0.4,0.4 s0.2,0.4,0.4,0.4c0,0,0,0,0,0h6.7c0.9,0,1.6-0.6,1.8-1.4l6-6c0.5-0.4,1.2-0.3,1.5,0.2c0.3,0.4,0.3,1,0,1.4L30.9,28 c-0.5,0.6-1.2,0.9-2,0.9H19l-1.3,1.3l-5.1-5L14.5,23.6z M10.8,24.6l7.5,7.5L16.5,34l-7.6-7.6L10.8,24.6z"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 12.3,
  y: 23.9,
  transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -16.7212 18.1727)",
  fill: "#C9C9C9",
  width: 2.6,
  height: 10.7
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M19,29h9.9c0.8,0,1.5-0.3,2-0.9l7.6-7.6c0.3-0.5,0.1-1.2-0.4-1.5c-0.3-0.2-0.8-0.2-1.1,0l-6,6 c-0.2,0.8-0.9,1.4-1.8,1.4h-6.7c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4c0,0,0,0,0,0h6.7c0.6,0,1-0.4,1-1s-0.4-1-1-1h-6.5l-0.8-0.5 c-2.3-1.6-5.4-1.4-7.4,0.5l-1.9,1.6l5.1,5.1L19,29z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M24.2,11.1v1.6c-0.9,0.5-1.4,1.4-1.4,2.4V18c0,1.6,1.2,2.8,2.8,2.9H30c1.5,0,2.8-1.3,2.8-2.8 c0,0,0-0.1,0-0.1v-2.9c0-1-0.5-1.9-1.4-2.4v-1.6c-0.3-2-2.2-3.3-4.1-3C25.7,8.4,24.5,9.6,24.2,11.1z M31,13.1c0.7,0.4,1.2,1.2,1.2,2 V18c0.1,1.2-0.9,2.2-2.1,2.3c0,0-0.1,0-0.1,0h-4.3c-1.2,0-2.2-1-2.2-2.2c0,0,0-0.1,0-0.1v-2.9c0-0.8,0.5-1.6,1.2-2l1-0.2H30 C30.3,12.9,30.6,12.9,31,13.1z M26.9,9.8c0.6-0.3,1.3-0.3,1.9,0c0.6,0.3,0.9,0.9,0.9,1.6v0.9H26v-0.9C26,10.8,26.3,10.2,26.9,9.8z  M30.8,11.1v1.3h-0.5v-1c0-0.9-0.5-1.7-1.2-2.1c-0.8-0.4-1.7-0.4-2.5,0c-0.7,0.5-1.2,1.2-1.2,2.1v0.9h-0.5v-1.2 c0.3-1.6,1.9-2.7,3.5-2.4C29.6,8.9,30.5,9.9,30.8,11.1z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#C9C9C9",
  d: "M24.9,11.1v1.3h0.5v-1c0-0.9,0.5-1.6,1.2-2.1c0.8-0.4,1.7-0.4,2.5,0c0.7,0.4,1.2,1.2,1.2,2.1v0.9h0.5v-1.2 c-0.3-1.6-1.9-2.7-3.5-2.4C26,8.9,25.1,9.9,24.9,11.1z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M27.9,16.2c0.2,0,0.4-0.3,0.4-0.5s-0.1-0.4-0.3-0.4s-0.3-0.1-0.5,0.1c-0.1,0.1-0.1,0.3-0.1,0.5 C27.5,16.1,27.7,16.2,27.9,16.2z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M25.7,12.9l-1,0.2c-0.7,0.4-1.2,1.2-1.2,2V18c-0.1,1.2,0.9,2.2,2.1,2.3c0,0,0.1,0,0.1,0H30 c1.2,0,2.2-1,2.2-2.2c0,0,0-0.1,0-0.1v-2.9c0-0.8-0.5-1.6-1.2-2c-0.3-0.2-0.7-0.2-1-0.2H25.7z M28.2,18.2c0,0.2-0.1,0.3-0.3,0.3 s-0.3-0.1-0.3-0.3v-1.5c-0.5-0.1-0.9-0.6-0.8-1.2c0,0,0,0,0,0c0.1-0.5,0.6-0.9,1.1-0.9c0.5,0,0.9,0.4,1,0.9c0.1,0.5-0.2,1.1-0.7,1.2 L28.2,18.2z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M28.9,15.5c-0.1-0.5-0.5-0.9-1-0.9c-0.5,0-1,0.4-1.1,0.9c-0.1,0.5,0.2,1.1,0.8,1.2c0,0,0,0,0,0v1.5 c0,0.2,0.1,0.3,0.3,0.3s0.3-0.1,0.3-0.3v-1.5C28.7,16.6,29,16,28.9,15.5z M27.4,15.9c0-0.2,0-0.4,0.1-0.5c0.2-0.2,0.4-0.2,0.5-0.1 c0.1,0.1,0.3,0.2,0.3,0.4s-0.2,0.5-0.4,0.5C27.7,16.2,27.5,16.1,27.4,15.9z"
});

function SvgAccessControl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessControl);
export default __webpack_public_path__ + "static/media/access_control.9968e8148a4d8d2d31dc71f12eb63e79.svg";
export { ForwardRef as ReactComponent };